import { render, staticRenderFns } from "./courseCartEnrollmentWaves.vue?vue&type=template&id=56ba52c0&scoped=true&"
import script from "./courseCartEnrollmentWaves.vue?vue&type=script&lang=js&"
export * from "./courseCartEnrollmentWaves.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ba52c0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
